import axios from "axios";
import { SERVER_URL } from "./config";

export async function getLoginToken(username, password) {
    
try {
    const res = await axios.post(SERVER_URL+'get-token', {
        username: username,
        password: password,
    });

    if (res.status === 200) {
        const token = res.data.token;
        localStorage.setItem('token', token);
        return token;
    } else {
        return false;
      }
    } catch (error) {
        return false
    }
}

export async function validateToken() {
    const token = localStorage.getItem('token');
    if (!token) {
        console.error("Token not found in localStorage.");
        return false;
    }

    try {
        const res = await axios.get(SERVER_URL + 'user_by_token', {
            headers: { Authorization: `Token ${token}` }, // Fix capitalization
        });

        if (res.status === 200) {
            const data = res.data;
            localStorage.setItem('issuperuser', data.superuser || false);
            return data; // Return the user's profile or relevant data
        } else {
            console.error("Token validation failed with status:", res.status);
            return false;
        }
    } catch (error) {
        console.error("Error validating token:", error.response?.data || error.message);
        return false;
    }
}

